export const enum Tasks {
  descend = '0',
  takeOff = '1',
  flight = '2',
  landing = '3'
}
